<template>
<div class="casino">
  <h1>Casino</h1>
</div>
</template>

<script>
export default {
  name: 'CasinoLayout',
}
</script>

<style lang="scss" scoped>
</style>
